import { render, staticRenderFns } from "./StepsFourth.vue?vue&type=template&id=157e2fde&scoped=true"
import script from "./StepsFourth.vue?vue&type=script&lang=js"
export * from "./StepsFourth.vue?vue&type=script&lang=js"
import style0 from "./StepsFourth.vue?vue&type=style&index=0&id=157e2fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e2fde",
  null
  
)

export default component.exports